module.exports = __webpack_public_path__ + "static/media/03.56f4fe86.jpg";